export default __webpack_public_path__ + "static/media/avatar-4.f7fb7ed7.png";